export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_08.97da51d4.png";